import { defineComponent as _defineComponent } from 'vue'
import type { ResponsiveImageSet } from '~/types/resource';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageGalleryImage',
  props: {
    image: null,
    alt: null
  },
  emits: ['click'],
  setup(__props: any) {




return { __sfc: true, }
}

})